/*
 * Stubbed for web, where we don't use this file;
 */
export default {};
